import { render, staticRenderFns } from "./GiudizioConlusivoViewComponent.vue?vue&type=template&id=445100b0"
import script from "./GiudizioConlusivoViewComponent.vue?vue&type=script&lang=js"
export * from "./GiudizioConlusivoViewComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports